import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WasteIntelligenceEngine from "./components/WasteIntelligenceEngine";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import About from "./pages/About";
import HowItWorks from "./pages/HowItWorks";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WasteIntelligenceEngine />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;